// KED: Judge.me star badges read "4,7 von 5 Sternen" instead of "4.7 (3)". Judge.me's text setting can only print
// the rating with a decimal point, so the badge text is set here from its data-average-rating value.
(() => {
  const german = (document.documentElement.lang || 'de').startsWith('de');

  const label = (rating) => {
    const value = rating.toLocaleString(german ? 'de-DE' : 'en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return german ? `${value} von 5 Sternen` : `${value} out of 5 stars`;
  };

  const update = () => {
    document.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach((badge) => {
      const text = badge.querySelector('.jdgm-prev-badge__text');
      const rating = parseFloat(badge.dataset.averageRating);
      if (!text || !rating) return;
      const next = label(rating);
      if (text.textContent.trim() !== next) text.textContent = next;
    });

    // The review carousel header prints "4.83 ★ (2,170)" with no data attributes, so read the numbers from it.
    document.querySelectorAll('.jdgm-rating-text').forEach((text) => {
      const count = text.querySelector('.jdgm-reviews-count');
      if (!count) return;
      const rating = parseFloat(text.textContent);
      const reviews = parseInt(count.textContent.replace(/[^\d]/g, ''), 10);
      if (!rating || !reviews) return;
      const total = reviews.toLocaleString(german ? 'de-DE' : 'en-GB');
      text.textContent = german ? `${label(rating)} aus ${total} Bewertungen` : `${label(rating)} from ${total} reviews`;
    });
  };

  // A short timer instead of requestAnimationFrame, which never fires in background tabs.
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      update();
    }, 50);
  };

  // Judge.me renders and re-renders badges after load, so keep watching for them.
  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
